import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function SectionHeading({ eyebrow, title, sub, dark = false, testId }) {
  return (
    <div className="max-w-3xl" data-testid={testId}>
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6, ease: EASE }}
        className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-gold"
      >
        <span className="h-px w-10 bg-gold/70" aria-hidden="true" />
        {eyebrow}
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.75, delay: 0.08, ease: EASE }}
        className={`mt-5 font-serif text-3xl font-semibold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl ${
          dark ? "text-cream" : "text-charcoal"
        }`}
      >
        {title}
      </motion.h2>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.16, ease: EASE }}
          className={`mt-5 text-base leading-relaxed sm:text-lg ${
            dark ? "text-cream/70" : "text-charcoal/70"
          }`}
        >
          {sub}
        </motion.p>
      )}
    </div>
  );
}
